// Define common social media platforms
const socialPlatforms = {
  telegram: {
    src: "/assets/images/Telegram.svg",
    alt: "Telegram",
  },
  instagram: {
    src: "/assets/images/instagram.png",
    alt: "Instagram",
  },
  reddit: {
    src: "/assets/images/reddit.svg",
    alt: "Reddit",
  },
  twitter: {
    src: "/assets/images/Twiter.svg",
    alt: "Twitter",
  },
  youtube: {
    src: "/assets/images/Youtube.svg",
    alt: "YouTube",
  },
  discord: {
    src: "/assets/images/discord.svg",
    alt: "Discord",
  },
  tiktok: {
    src: "/assets/images/tiktok.svg",
    alt: "TikTok",
  },
  twitch: {
    src: "/assets/images/twitch.svg",
    alt: "Twitch",
  },
}

// Define brand-specific URLs
const socialUrls = {
  pukkawin: {},
  betkudos: {
    telegram: "https://t.me/BetkudosCasino",
    instagram: "https://www.instagram.com/bet_kudos/?hl=en",
    twitter: "https://x.com/Bet_kudos",
    discord: "https://discordapp.com/users/betkudoscasino",
  },
  sojibet: {},
  betevet: {},
  zlatobet: {
    telegram: "https://t.me/zlatobet_casino",
    instagram: "https://www.instagram.com/zlatobet/",
    twitter: "https://x.com/zlatobet",
    discord: "https://discordapp.com/users/zlatobet",
    twitch: "https://www.twitch.tv/zlatobet",
  },
  wilderbet: {},
}

// Helper function to generate social links for a brand
function generateSocialLinks(brandName) {
  const urls = socialUrls[brandName] || {}

  return Object.entries(socialPlatforms).map(([platform, info]) => ({
    ...info,
    ...(urls[platform] ? { url: urls[platform] } : {}),
  }))
}

export const brands = {
  pukkawin: {
    title: "Pukkawins",
    name: "pukkawin",
    address: "Kaya W.F.G. (Jombi) Mensing 24 Unit A, Willemstad, Curacao",
    socialLinks: generateSocialLinks("pukkawin"),
    email: "support@pukkawin.com",
    bonusGame: "Bonanza Billions (BGaming)",
    licenseNumber: "OGL/2024/1581/0803",
    meta: {
      title: "Bet Beyond Limits – Crypto Casino, No Boundaries",
      description: "Join Crypto Casino, Live games, Friendly support, Multiple cryptocurrencies, Fast Withdrawals",
      image: "/assets/images/logo/pukkawin.png",
      favicon: "/assets/images/favicon/pukkawin.png",
    },
  },
  betkudos: {
    title: "BetKudos",
    name: "betkudos",
    address: "Kaya W.F.G. (Jombi) Mensing 24 Unit A, Willemstad, Curacao",
    licenseNumber: "OGL/2024/1581/0803",
    licenseToken:
      "ZXlKcGRpSTZJbTVGYzBRMk16RklVbU5qYXk4MUszaGxhVTAwUmtFOVBTSXNJblpoYkhWbElqb2lPVmh0WlRaUUwxWXJkR042VWl0UFFtNHlWbkpOV1ZjeWJrZHljMHRLU0VkMmFEWmxkVlZuYW5wbVdUMGlMQ0p0WVdNaU9pSmpPV1l3WWprM05qZzFOemN6TkdWaE1tSXhZMlpqT0RaaFl6a3lZelU1WXpnd00yUTFZek15Tm1Oa1lXSTNOak0zTnpZME1UWTJaamRpTURWaU1XWmpJaXdpZEdGbklqb2lJbjA9",
    socialLinks: generateSocialLinks("betkudos"),
    email: "support@betkudos.com",
    bonusGame: "Bonanza Billions (BGaming)",
    rulesFile: "/content/rules/betkudos-rules.md",
    meta: {
      title: "Bet Beyond Limits – Crypto Casino, No Boundaries",
      description: "Join Crypto Casino, Live games, Friendly support, Multiple cryptocurrencies, Fast Withdrawals",
      image: "/assets/images/logo/betkudos.png",
      favicon: "/assets/images/favicon/betkudos.png",
    },
  },
  sojibet: {
    title: "SojiBet",
    name: "sojibet",
    address: "Kaya W.F.G. (Jombi) Mensing 24 Unit A, Willemstad, Curacao",
    email: "support@sojibet.com",
    licenseNumber: "OGL/2024/1581/0803",
    licenseToken:
      "ZXlKcGRpSTZJbFpUTDBSdkwyUmhhbHBVVlhOaWJVcExPVU15U1djOVBTSXNJblpoYkhWbElqb2lTbU50YlZWcFR6azFTWGc1VkRjM1dUWkVTa1JFVVQwOUlpd2liV0ZqSWpvaU5EQXpObVZqWmpJNE1UUmhOMkkxTkdZNU1UVXlObUkxWm1ZNU1qWmpaR0kyTkRnNU5XWTRNREUyTXpJMVpqVmtOVGN6TnpVM01EYzJaak16WXpnMllpSXNJblJoWnlJNklpSjk=",
    socialLinks: generateSocialLinks("sojibet"),
    bonusGame: "Bonanza Billions (BGaming)",
    meta: {
      title: "Bet Beyond Limits – Crypto Casino, No Boundaries",
      description: "Join Crypto Casino, Live games, Friendly support, Multiple cryptocurrencies, Fast Withdrawals",
      image: "/assets/images/logo/sojibet.png",
      favicon: "/assets/images/favicon/sojibet.png",
    },
  },
  betevet: {
    title: "Betevet",
    name: "betevet",
    address: "Kaya W.F.G. (Jombi) Mensing 24 Unit A, Willemstad, Curacao",
    email: "destek@betevet.com",
    licenseNumber: "OGL/2024/1581/0803",
    licenseToken:
      "ZXlKcGRpSTZJa1JETXprNE1rRkdTbFJOVEdObGJFNUxhR3hyWkVFOVBTSXNJblpoYkhWbElqb2lkUzkxT1Vsb2FYTnJPRUZoUjNoamMySnFiV1YwVVQwOUlpd2liV0ZqSWpvaVlURmtPR1F3Tm1FMlpHTmlObU15T0RVMU5XVmxaRFF6WmpKak9UUm1Nams0WkdWbU9ERTJORGMzWmpJMk1HVmlOemhpTlRFeU9XRXlNMk0yT1dOaE9TSXNJblJoWnlJNklpSjk=",
    socialLinks: generateSocialLinks("betevet"),
    bonusGame: "Bonanza Billions (BGaming)",
    rulesFile: "/content/rules/betevet-rules.md",
    meta: {
      title: "Betevet – Türkiye'nin En Güvenilir ve En Çok Bonus Veren Online Kripto Casino ve Bahis Sitesi",
      description: "Betevet.com, yüksek bonusları ve hızlı ödeme seçenekleriyle Türkiye'nin önde gelen online kripto casino ve bahis platformudur.",
      keywords: "kripto casino, online casino, gazino oyna, casino oyna, casino bonus, gazino bonusu, en çok bonus veren casino",
      image: "/assets/images/logo/betevet.png",
      favicon: "/assets/images/favicon/betevet.png",
    },
  },
  zlatobet: {
    title: "Zlatobet",
    name: "zlatobet",
    address: "Kaya W.F.G. (Jombi) Mensing 24 Unit A, Willemstad, Curacao",
    email: "support@zlatobet.com",
    licenseNumber: "OGL/2024/1581/0803",
    licenseToken:
      "ZXlKcGRpSTZJbTEwUkRKRVJUaElaMDhyWjNJNGIwTXhRM1J1U1hjOVBTSXNJblpoYkhWbElqb2lRMjVuVlRWdFQwTktla1JuVDJWRlV6WlpRMHRGUVQwOUlpd2liV0ZqSWpvaU1ESmpNbVZrTVRZMVkyUm1OelZsTm1NeVpqRXhZalU1TW1Ga1pqVmpPR1ptTkRkbU5HRXlNekV4TVdVMllqVmtOamRoWmpNMFpHWTBZV0k1T1RsaU1DSXNJblJoWnlJNklpSjk=",
    socialLinks: generateSocialLinks("zlatobet"),
    bonusGame: "Aviator (Spribe)",
    rulesFile: "/content/rules/zlatobet-rules.md",
    meta: {
      title: "ZlatoBet.com – Strike Gold in the World of Crypto Gaming",
      description: "ZlatoBet is your gateway to premium crypto casino action. Play top-tier slots, live tables, and provably fair games — all powered by lightning-fast crypto deposits and withdrawals. Where fortune meets the future.",
      image: "/assets/images/logo/zlatobet.png",
      favicon: "/assets/images/favicon/zlatobet.png",
    },
  },
  wilderbet: {
    title: "Wilderbet",
    name: "wilderbet",
    address: "Kaya W.F.G. (Jombi) Mensing 24 Unit A, Willemstad, Curacao",
    email: "support@wilderbet.com",
    licenseNumber: "OGL/2024/1581/0803",
    licenseToken:
      "ZXlKcGRpSTZJbHBzVldGUVduY3JibE50UkZaNGNFb3hLemR3WW5jOVBTSXNJblpoYkhWbElqb2lNUzlKVFZoV1JHRkRkM3BFY1RGQ1FtMVljMkZrVVQwOUlpd2liV0ZqSWpvaU1HVTROalpsTmpnMU9UY3hPVEF5WkRReU5XUTJOalZpWmpjeU1qZGxNR1ZqWlRrNU56RmhNRFl5TjJJelkyRTBOVEF4T0dVMU1Ea3hPVGRoTnpjME5pSXNJblJoWnlJNklpSjk=",
    socialLinks: generateSocialLinks("wilderbet"),
    bonusGame: "Aviator (Spribe)",
    rulesFile: "/content/rules/wilderbet-rules.md",
    meta: {
      title: "Wilderbet",
      description: "Wilderbet is your gateway to premium crypto casino action. Play top-tier slots, live tables, and provably fair games — all powered by lightning-fast crypto deposits and withdrawals. Where fortune meets the future.",
      image: "/assets/images/logo/wilderbet.png",
      favicon: "/assets/images/favicon/wilderbet.png",
    },
  },
}
